import gsap from 'gsap';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';
import { Lang } from '../common/lang';

export default class LanguageSelection {
  constructor(camera, canvas) {
    this.tapAudio = document.querySelector('#tapAudio');
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    document.querySelector('#english').addEventListener('click', () => {
      Global.soundEnabled && this.tapAudio.play();

      Global.soundEnabled &&
        ((document.querySelector('#BGAudio').volume = 0.2),
        document.querySelector('#BGAudio').play());

      this.language('ENG');
    });
    document.querySelector('#arabic').addEventListener('click', () => {
      Global.soundEnabled && this.tapAudio.play();
      Global.soundEnabled &&
        ((document.querySelector('#BGAudio').volume = 0.2),
        document.querySelector('#BGAudio').play());
      this.language('ARB');
    });
    // setTimeout(() => {
    //   this.language('ARB');
    // }, 100);
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'Language') return false;

    document.querySelector('#languageSelection_screen').classList.add('active');

    gsap.delayedCall(0.5, () => {
      document
        .querySelector('#languageSelection_screen')
        .classList.add('active2');
    });

    gsap.delayedCall(0.2, this.animateScreen.bind(this));
  }
  animateScreen() {
    gsap.delayedCall(0, () => {
      document
        .querySelector('#languageSelection_screen .chooseBox')
        .classList.add('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#languageSelection_screen .text')
        .classList.add('active');
    });
    gsap.delayedCall(0.3, () => {
      document
        .querySelector(
          '#languageSelection_screen .btn_container:nth-child(1) .btn'
        )
        .classList.add('active');
    });
    gsap.delayedCall(0.4, () => {
      document
        .querySelector(
          '#languageSelection_screen .btn_container:nth-child(2) .btn'
        )
        .classList.add('active');
    });
  }
  language(lang) {
    // document.querySelector('#BGAudio').volume = 0.2;
    // Global.soundEnabled && document.querySelector('#BGAudio').play();
    document.querySelector('#languageSelection_screen').style.display = 'none';
    // this.events.addEventListener('USER_EVENTS', this.changeScreen.bind(this,''));

    document.querySelector('#tc').innerHTML = Lang['tc'][lang];
    document.querySelector('#privacy').innerHTML = Lang['privacy'][lang];
    document.querySelector('#start').innerHTML = Lang['start'][lang];
    document.querySelector('#details').innerHTML = Lang['details'][lang];
    document.querySelector('#name').placeholder = Lang['name'][lang];
    document.querySelector('#email').placeholder = Lang['email'][lang];
    document.querySelector('#mobile').placeholder = Lang['mobile'][lang];
    document.querySelector('#country option[value=""]').textContent =
      Lang?.country?.[lang] || 'COUNTRY';
    document.querySelector('#submit').innerHTML = Lang['next'][lang];
    document.querySelector('#uploadPhoto').innerHTML =
      Lang['uploadPhoto'][lang];
    document.querySelector('#upload').innerHTML = Lang['upload'][lang];
    document.querySelector('#skip').innerHTML = Lang['skip'][lang];
    document.querySelector('.pinch').innerHTML = Lang['pinch'][lang];
    document.querySelector('#choose').innerHTML = Lang['choose'][lang];
    document.querySelector('#play').innerHTML = Lang['play'][lang];
    document.querySelector('#how').innerHTML = Lang['how'][lang];
    document.querySelector('#how').innerHTML = Lang['how'][lang];
    document.querySelector('#use').innerHTML = Lang['use'][lang];
    document.querySelector('#avoid').innerHTML = Lang['avoid'][lang];
    document.querySelector('#collect').innerHTML = Lang['collect'][lang];
    document.querySelector('#have').innerHTML = Lang['have'][lang];
    document.querySelector('#congrats').innerHTML = Lang['congrats'][lang];
    document.querySelector('.scoreText').innerHTML = Lang['yourScore'][lang];
    document.querySelector('#leaderboardText').innerHTML =
      Lang['leaderboard'][lang];
    document.querySelector('#tryAgain').innerHTML = Lang['tryAgain'][lang];
    document.querySelector('#share').innerHTML = Lang['share'][lang];
    document.querySelector('#rank').innerHTML = Lang['rank'][lang];
    document.querySelector('#nameRank').innerHTML = Lang['name'][lang];
    document.querySelector('#scoreRank').innerHTML = Lang['score'][lang];
    if (lang == 'ARB') {
      document.querySelector("#country option[value='UAE']").innerHTML =
        'الإمارات العربية المتحدة';

      document.querySelector("#country option[value='KSA']").innerHTML =
        'المملكة العربية السعودية';
      document.querySelector("#country option[value='Morocco']").innerHTML =
        'المغرب';
      document.querySelector("#country option[value='Iraq']").innerHTML =
        'العراق';

      document.querySelector("#country option[value='Jordan']").innerHTML =
        'الأردن';
      document.querySelector("#country option[value='Lebanon']").innerHTML =
        'لبنان';
      document.querySelector("#country option[value='Palestine']").innerHTML =
        'فلسطين';
      document.querySelector("#country option[value='Kuwait']").innerHTML =
        'الكويت';
      document.querySelector("#country option[value='Oman']").innerHTML =
        'عُمان';
      document.querySelector("#country option[value='Bahrain']").innerHTML =
        'البحرين';
      document.querySelector("#country option[value='Qatar']").innerHTML =
        'قطر';
      document.querySelector("#country option[value='Egypt']").innerHTML =
        'مصر';
      document.querySelector("#country option[value='Libya']").innerHTML =
        'ليبيا';

      document.querySelector("#country option[value='Réunion']").innerHTML =
        'ريونيون';
      document.querySelector("#country option[value='Mauritius']").innerHTML =
        'موريشيوس';

      document.querySelector('.joystick_intro').classList.add('ar');
      document.querySelector('.pop').classList.add('ar');
      document.querySelector('.errorSec').classList.add('ar');
      document.querySelector('body').dir = 'rtl';
      document.querySelector('body').classList.add('ar');
      document.querySelector('select').style.backgroundPosition = '1%';
    } else {
      document.querySelector('.errorSec').classList.remove('ar');
      document.querySelector('body').dir = 'ltr';
      document.querySelector('body').classList.remove('ar');
    }
    Global.lang = lang;

    Global.serverObj.send(
      `${Global.BASE_URL}webservice.php`,
      (response) => {},
      null,
      {
        saveType: 'saveLanguage',
        language: lang,
      },
      'POST',
      null,
      false
    );
    document
      .querySelector('.main')
      .classList.add(Global.lang == 'ENG' ? 'en' : 'ar');

    document
      .querySelector('#languageSelection_screen')
      .classList.remove('active');
    document
      .querySelector('#languageSelection_screen')
      .classList.remove('active2');
    gsap.delayedCall(0.0, () => {
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_screen',
          data: {
            screenKey: 'StartScreen', //
          },
        },
      });
    });
  }
}
